var _g, _defs, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSupport = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 114,
  height: 96,
  viewBox: "0 0 114 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#support_svg__filter0_ddi_4438_2804)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.406 66.7193C55.156 67.4793 55.156 68.7093 54.406 69.4693L50.946 72.9393C50.196 73.6993 48.966 73.6993 48.216 72.9393L39.566 64.2493C38.816 63.4893 38.816 62.2593 39.566 61.4993L43.026 58.0293C43.776 57.2693 45.006 57.2693 45.756 58.0293L54.406 66.7193ZM80.026 32.2793C78.276 30.5193 75.706 30.0993 73.556 31.0093L81.296 38.7793C82.196 36.6193 81.776 34.0393 80.026 32.2793ZM40.236 72.2593C41.986 74.0193 44.556 74.4393 46.706 73.5293L38.966 65.7593C38.066 67.9193 38.486 70.4993 40.236 72.2593ZM65.286 28.0793C57.226 19.9793 44.106 19.9793 36.046 28.0793C27.986 36.1793 27.986 49.3593 36.046 57.4593L38.046 59.4693L41.106 56.3993L39.106 54.3893C32.726 47.9793 32.726 37.5593 39.106 31.1493C45.486 24.7393 55.856 24.7393 62.236 31.1493L64.236 33.1593L67.296 30.0893L65.296 28.0793H65.286ZM80.136 45.5693L78.586 47.1293C82.416 50.9793 82.836 56.9493 79.886 61.2893C78.816 60.9193 77.576 61.1293 76.726 61.9893L74.306 64.4193C73.116 65.6093 73.116 67.5593 74.306 68.7493C75.496 69.9393 77.436 69.9393 78.616 68.7493L81.036 66.3193C82.006 65.3493 82.136 63.8893 81.526 62.7393C85.226 57.5293 84.786 50.2393 80.136 45.5693ZM77.166 46.5793L80.626 43.1093C81.376 42.3493 81.376 41.1193 80.626 40.3593L71.976 31.6693C71.226 30.9093 69.996 30.9093 69.246 31.6693L65.786 35.1393C65.036 35.8993 65.036 37.1293 65.786 37.8893L74.436 46.5793C75.186 47.3393 76.416 47.3393 77.166 46.5793Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "support_svg__filter0_ddi_4438_2804",
  x: 0.000976562,
  y: -7.99573,
  width: 113.999,
  height: 111.992,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.808333 0 0 0 0 0.49443 0 0 0 0 0.0235764 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4438_2804"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_4438_2804",
  result: "effect2_dropShadow_4438_2804"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_4438_2804",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect3_innerShadow_4438_2804"
})))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "support_svg__yellow",
  x1: 30.0019,
  y1: 22.0043,
  x2: 77.6965,
  y2: 81.237,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "support_svg__gray",
  x1: 30.0019,
  y1: 22.0043,
  x2: 77.6965,
  y2: 81.237,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#CECEE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))));
export { SvgSupport as ReactComponent };
export default __webpack_public_path__ + "assets/icons/support.53ce04.svg";